<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
    />
    <Editor
        style="height: 500px; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
        @onChange="onChange"
        @onDestroyed="onDestroyed"
        @onMaxLength="onMaxLength"
        @onFocus="onFocus"
        @onBlur="onBlur"
        @customAlert="customAlert"
        @customPaste="customPaste"
    />
  </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import pub from "@/api/public";

export default {
  name: 'editor',
  components: {Editor, Toolbar},
  props: ['content'], // 声明接收的参数
  data() {
    return {
      upload_url: '',
      editor: null,
      mode: 'default',
      html: this.content,
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        // excludeKeys: [ /* 隐藏哪些菜单 */ ],
      },
      editorConfig: {
        placeholder: '请输入内容...',
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {}
      }
    }
  },
  created() {
    const uploadConfig = {
      // 图片 上传
      async customUpload(file, insertFn) {
        // file 即选中的文件
        const fd = new FormData()
        fd.append('file', file)
        pub.uploadFile(fd).then(res => {
          // 插入图片
          insertFn(res.data[0].url);
        })
      },
    }
    // 图片配置设置
    this.editorConfig.MENU_CONF['uploadImage'] = uploadConfig
    // 视频配置设置
    this.editorConfig.MENU_CONF['uploadVideo'] = uploadConfig
  },
  methods: {
    //调用组件 函数传递数据
    contents(val){
      this.html = val;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor)
      console.log('onCreated', editor)
    },
    onChange(editor) {
      console.log('onChange', editor.children)
      this.$emit('change', editor.getHtml())
    },
    onDestroyed(editor) {
      console.log('onDestroyed', editor)
    },
    onMaxLength(editor) {
      console.log('onMaxLength', editor)
    },
    onFocus(editor) {
      console.log('onFocus', editor)
    },
    onBlur(editor) {
      console.log('onBlur', editor)
    },
    customAlert(info, type) {
      window.alert(`customAlert in Vue demo\n${type}:\n${info}`)
    },
    customPaste(editor, event, callback) {
      console.log('ClipboardEvent 粘贴事件对象', event)
      // const html = event.clipboardData.getData('text/html') // 获取粘贴的 html
      // const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
      // const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）

      // 自定义插入内容
      //editor.insertText('')
      // 返回 false ，阻止默认粘贴行为
      event.preventDefault()
      //callback(false) // 返回值（注意，vue 事件的返回值，不能用 return）
      // 返回 true ，继续默认的粘贴行为
       callback(true)
    },
  },
  // 组件销毁时，也及时销毁编辑器
  beforeUnmount() {
    try {
      const editor = this.editor
      if (editor == null) return
      setTimeout(() => {
        editor.destroy() // 组件销毁时，及时销毁编辑器
        //console.log('editor销毁完成')
      }, 300) // 添加1秒的延迟
    } catch (error) {
      console.log('捕获了', error)
    }
  },
}
</script>
